import type { GetImpactCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetImpactCount = createQueryHook<
  Record<string, never>,
  number,
  GetImpactCountQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.impact.impactCount.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    impact_aggregate: {
      aggregate: {
        count: data ?? 0,
      },
    },
  }),
  graphqlDocument: GetImpactCountDocument,
});
